<template>
  <TableLayout :permissions="['business:baseparam:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      
      <el-form-item label="原因" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入原因" @keypress.enter.native="search"></el-input>
      </el-form-item>
      
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:baseparam:create']">
        <li><el-button type="primary" @click="$refs.operaReturnReasonWindow.open('新建强制还车原因')" icon="el-icon-plus" v-permissions="['business:baseparam:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <!-- <el-table-column prop="id" label="编码" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="编辑时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="编辑人" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column> -->
        <el-table-column prop="name" label="强制还车原因" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="required" label="备注是否必填" min-width="100px" align="center">
          <template slot-scope="{row}">
            {{row.required==0 ?   '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="sortnum" label="排序码（升序）" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px" align="center"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:baseparam:update', 'business:baseparam:delete'])"
          label="操作"
          min-width="120"
          align="center"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaReturnReasonWindow.open('编辑强制还车原因', row)" icon="el-icon-edit" v-permissions="['business:baseparam:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:baseparam:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaReturnReasonWindow ref="operaReturnReasonWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaReturnReasonWindow from '@/components/business/OperaReturnReasonWindow'
export default {
  name: 'BaseParam',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaReturnReasonWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        name: '',
        sortnum: '',
        type: '1', // 0车辆保修原因 1强制还车原因 2时长减免原因 3单车类型
        status: '',
        info: '',
        required: ''
      }
    }
  },
  created () {
    this.config({
      module: '系统基础配置表',
      api: '/business/baseParam',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
